import { Button } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

const ExpandRowButton = (props) => {
    const {
        expanded,
        handleClick
    } = props;

    return (
        <Button onClick={handleClick}>
            {expanded ? <ZoomOutIcon/> : <ZoomInIcon/>}
        </Button>
    )
}

export default ExpandRowButton;